import { useState, useEffect } from 'react';

/**
 * Tracks browser online/offline status reactively.
 * Returns true when the device has a network connection.
 */
export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const setOnline  = () => setIsOnline(true);
    const setOffline = () => setIsOnline(false);

    window.addEventListener('online',  setOnline);
    window.addEventListener('offline', setOffline);

    return () => {
      window.removeEventListener('online',  setOnline);
      window.removeEventListener('offline', setOffline);
    };
  }, []);

  return isOnline;
}
